import { ADD_ON_IDS } from '../add-ons/constants';
import { PLAN_GROUP_IDS } from '../plan-detail/constants';

export interface CountryConfig {
  countryCode: string;
  currency: string;
  currencySymbol: string;
  inboxPreviewAddOnId: string;
  supportPhone?: string | null;
  planGroups: number[];
}

export const COUNTRY_CONFIGS: Record<string, CountryConfig> = {
  US: {
    countryCode: 'US',
    currency: 'USD',
    currencySymbol: '$',
    inboxPreviewAddOnId: ADD_ON_IDS.IBP,
    supportPhone: '855-229-5506',
    planGroups: [],
  },
  AU: {
    countryCode: 'AU',
    currency: 'AUD',
    currencySymbol: 'A$',
    inboxPreviewAddOnId: ADD_ON_IDS.IBP,
    supportPhone: '1800-290-803',
    planGroups: [PLAN_GROUP_IDS.AUSTRALIA_V1],
  },
  GB: {
    countryCode: 'GB',
    currency: 'GBP',
    currencySymbol: '£',
    inboxPreviewAddOnId: ADD_ON_IDS.IBP,
    // null until CBU-21269; myaccount-utils getSupportPhoneNumber falls back to the US number
    supportPhone: null,
    planGroups: [PLAN_GROUP_IDS.GREAT_BRITAIN_V1, PLAN_GROUP_IDS.GREAT_BRITAIN_LEAD_MAGNET],
  },
};

export const getCountryConfig = (countryCode?: string): CountryConfig => {
  const normalized = countryCode?.toUpperCase();

  return COUNTRY_CONFIGS[normalized ?? ''] ?? COUNTRY_CONFIGS.US;
};

export const getCountryConfigByPlanGroup = (planGroupId?: number): CountryConfig | undefined => {
  if (planGroupId == null) return undefined;

  return Object.values(COUNTRY_CONFIGS).find((config) => config.planGroups.includes(planGroupId));
};
